import { USER } from "./actions";
import UserService from "../services/user-service";

const MUTATION = {
  SET_USER: "SET_USER",
  LOGOUT: "LOGOUT"
};

export default {
  namespaced: true,
  state: {
    isAuthenticated: false,
    firstName: null,
    lastName: null,
    email: null
  },
  mutations: {
    [MUTATION.SET_USER](state, user) {
      state.isAuthenticated = true;
      state.firstName = user.firstName;
      state.lastName = user.lastName;
      state.email = user.email;
    },
    [MUTATION.LOGOUT](state) {
      state.isAuthenticated = false;
      state.firstName = null;
      state.lastName = null;
      state.email = null;
    }
  },
  actions: {
    async [USER.LOGIN]({ dispatch }, { email, password }) {
      await UserService.login(email, password);
      await dispatch(USER.SET_PROFILE);
    },
    async [USER.SET_PROFILE]({ commit }) {
      const user = await UserService.getProfile();
      commit(MUTATION.SET_USER, user);
    },
    async [USER.LOGOUT]({ commit }) {
      await UserService.logout();
      commit(MUTATION.LOGOUT);
    }
  }
};
